import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.

 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  // connectedCallback() {
  //   super.connectedCallback();
  //       // If Unicorn cart is active, do not bind theme cart auto-open
  //   if (window.Unicorn || document.querySelector('[data-unicorn-cart], .unicorn-cart, unicorn-cart')) {
  //     return;
  //   }

  //   document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  // }

  // disconnectedCallback() {
  //   super.disconnectedCallback();
  //   document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  // }

  // #handleCartAdd = () => {
  //     #handleCartAdd = () => {
  //   // If Unicorn cart is active, do nothing
  //   if (window.Unicorn || document.querySelector('[data-unicorn-cart], .unicorn-cart, unicorn-cart')) {
  //     return;
  //   }

  //   if (this.hasAttribute('auto-open')) {
  //     this.showDialog();
  //   }
  // };

  //   if (this.hasAttribute('auto-open')) {
  //     this.showDialog();
  //   }
  // };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
